import { type MatchPageView, BETBUILDER_URL_SLUG, MICROBETTING_URL_SLUG } from './routes';

const isMatchPageView = (slug: string): slug is MatchPageView =>
  [BETBUILDER_URL_SLUG, MICROBETTING_URL_SLUG].includes(slug);

export { isMatchPageView };
